import React, { useState } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";

const cellStyle = {
  whiteSpace: "nowrap",
  borderRight: "1px solid #ddd",
  // textAlign: "center",
  py: 1.7,
  fontSize: "12px",
};
const menuitemStyle = {
  fontSize: "13px",
  "&:hover": { backgroundColor: "rgba(253, 87, 7, 0.1)" },
};
const iconStyle = { fontSize: "18px", mr: 0.5 };

function UserManagementTableBody({ filledRows }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modal2Open, setModal2Open] = useState(false);
  const [currUserId, setcurrUserId] = useState(null);
  const handleClick = (event, contactId) => {
    setcurrUserId(contactId);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <TableBody>
        {filledRows?.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            <TableCell sx={cellStyle}>{row?.name || "UserName"}</TableCell>
            <TableCell sx={cellStyle}>{row?.employee || "XXXXXX"}</TableCell>
            <TableCell sx={cellStyle}>
              {row?.designation || "Designation"}
            </TableCell>
            <TableCell sx={cellStyle}>
              {row?.email || "name@example.domain"}
            </TableCell>
            <TableCell sx={cellStyle}>
              {row?.phone || "(000) 000 0000"}
            </TableCell>
            <TableCell sx={cellStyle}>{row?.shift || "A"}</TableCell>
            <TableCell sx={cellStyle}>{row?.role || "User"}</TableCell>
            <TableCell sx={cellStyle}>
              {row?.activity || "Signed In 18/11/2023 12:34:26"}
            </TableCell>
            <TableCell sx={cellStyle}>
              <IconButton
                onClick={(e) => handleClick(e, row?.userId)}
                sx={{ padding: 0 }}
              >
                <MoreVertIcon sx={{ color: "#9F9F9F" }} />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          onClick={() => {
            setModal2Open(!modal2Open);
            handleClose();
          }}
          sx={menuitemStyle}
        >
          <EditIcon sx={iconStyle} />
          Edit User
        </MenuItem>
        <MenuItem
          onClick={() => {
            setModalOpen(!modalOpen);
            handleClose();
          }}
          sx={menuitemStyle}
        >
          <DeleteForeverIcon sx={iconStyle} />
          Delete User
        </MenuItem>
      </Menu>
    </>
  );
}

export default UserManagementTableBody;
